import theme, { SCROLLBAR_GUTTER_WIDTH } from "@styles/theme";

import { styled } from "@mui/system";

export const headerHeight = `56px`;
export const footerHeight = `48px`;
export const footerTabletHeight = `102px`;
export const footerMobileHeight = `165px`;
export const panelWidth = `240px`;

export const Documents = styled("div")(() => ({
    minHeight: `100%`,
    height: `100%`,
    overflow: `hidden`,
    display: `flex`,
}));

// DAM-646: 콘솔 본문 스크롤 컨테이너. overflow: auto 만 있으면 콘텐츠가 길어져 스크롤바가
//          생기는 순간 본문 전체가 스크롤바 폭만큼 왼쪽으로 밀린다(클래식 스크롤바 환경에서
//          실측 11px). 창 높이만 바꿔도 재현되고 거의 모든 화면이 이 컨테이너를 쓴다.
//          자리를 상시 확보하고, 늘어나는 만큼 우측 패딩에서 덜어내 기존 여백을 유지한다.
//          ⚠️ 예약 폭은 OS·브라우저마다 다르므로 상수로 박지 않고 CSS 변수 한 곳에서 관리한다.
//          DAM-658: 같은 값을 다이얼로그 여백 보정도 쓰게 되어 theme.js 로 올렸다. 정의는 한 곳뿐이다.
const scrollbarGutterWidth = SCROLLBAR_GUTTER_WIDTH;

export const Main = styled("main")(({ theme }) => ({
    flex: 1,
    height: `100%`,
    minWidth: 0,
    padding: theme.spacing(2, 5, 0),
    paddingRight: `calc(${theme.spacing(5)} - ${scrollbarGutterWidth})`,
    overflow: `auto`,
    scrollbarGutter: `stable`,
    display: `flex`,
    flexDirection: `column`,
    transition: `linear padding 0.2s`,
    [theme.breakpoints.down("xl")]: {
        padding: theme.spacing(2, 3, 0),
        paddingRight: `calc(${theme.spacing(3)} - ${scrollbarGutterWidth})`,
        transition: `linear padding 0.2s`,
    },
}));

export const Container = styled("div")(() => ({
    flex: 1,
    boxSizing: `border-box`,
    height: `100%`,
    minWidth: 0,
    overflow: `hidden`,
    display: `flex`,
    flexDirection: `column`,
    width: `calc(100vh - ${panelWidth})`,
}));

export const EmptyContent = styled("div")(() => ({
    display: `flex`,
    flexDirection: `column`,
    justifyContent: `center`,
    alignItems: `center`,
    flexWrap: `wrap`,
    maxWidth: `1280px`,
    height: `calc(100vh - ${headerHeight}px - ${footerHeight})`,
    marginTop: `${headerHeight}px`,
    textAlign: `center`,
    [theme.breakpoints.down("xl")]: {
        minHeight: `calc(100vh - ${footerTabletHeight})`,
        margin: `0 auto -${footerTabletHeight}`,
        padding: `32px 0 ${footerTabletHeight}`,
    },
    [theme.breakpoints.down("md")]: {
        minHeight: `calc(100vh - ${footerMobileHeight})`,
        margin: `0 auto -${footerMobileHeight}`,
        padding: `32px 0 ${footerMobileHeight}`,
    },
}));
